/**
 * I passi del tutorial guidato di Incoming/Outcoming > Inventario.
 *
 * Nessun preparativo, nemmeno per i due menu della pagina: hanno una voce sola
 * ciascuno e il passo la racconta senza doverli aprire, cosi' non serve un
 * `onStop` che richiuda niente.
 *
 * La tabella della scansione e le righe dell'inventario stanno dietro un `v-if`
 * sui dati: a inventario vuoto quei passi si agganciano in basso e raccontano
 * lo stesso cosa ci si trovera'.
 */
const at = name => `[data-tour-scope="warehouse-inventory"] [data-tour="${name}"]`;

export function createWarehouseInventoryTourSteps() {
	return [
		{
			body: "Qui si conta il magazzino. La differenza con Carico e Scarico e' tutta in una parola: quelli muovono le giacenze di un pezzo alla volta, questo le SOSTITUISCE con quello che hai contato. Se il sistema dice 40 e tu scrivi 7, alla conferma diventa 7 - non 47 e non 33. E' la pagina che rimette i numeri in pari con la realta' dello scaffale.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Un conteggio che sostituisce',
		},
		{
			body: "Il conteggio non si fa per forza da questo schermo: inquadrando il QR si scarica l'app per Android, che fa da lettore con la fotocamera del telefono. Comoda quando il magazzino e' grande e il computer sta dall'altra parte del capannone - l'inventario che compili con l'app e' lo stesso che vedi qui.",
			key: 'app',
			placement: 'right',
			target: at('app'),
			title: 'Contare col telefono',
		},
		{
			body: "Non c'e' niente da cliccare prima di leggere: la pagina ascolta la tastiera per intero, e un lettore barcode per il computer non e' altro che una tastiera che digita in fretta e preme Invio alla fine. Il campo e' in sola lettura - ci compare l'ultimo codice letto, ma non si scrive a mano. Se il codice non e' su nessun prodotto, compare un avviso rosso.",
			key: 'scan',
			placement: 'bottom',
			target: at('scan'),
			title: 'Come si legge un codice',
		},
		{
			body: "Se la pistola non c'e' o il computer e' lontano, il telefono fa da lettore: premi LEGGI CON IL TELEFONO, inquadra il QR che compare e sul telefono si apre la fotocamera - niente app da installare. Legge EAN-13 ed EAN-8, UPC, Code128, Code39, QR e DataMatrix. Ogni codice va confermato con INVIA sul telefono, cosi' un doppio scatto non passa inosservato. Il collegamento resta attivo anche passando alle altre pagine del magazzino, finche' non premi DISCONNETTI. E' diverso dall'app Android del QR a sinistra: qui il telefono manda solo il codice a questa pagina, che prepara la riga di conta come farebbe la pistola.",
			key: 'phone',
			placement: 'bottom',
			target: at('phone'),
			title: 'Leggere con il telefono',
		},
		{
			body: "Letto il codice compare il prodotto con un campo Quantita' in magazzino: li' dentro scrivi quanti pezzi hai contato davvero, poi premi CONFERMA. Qui, a differenza di Carico e Scarico, niente si muove da solo: la lettura prepara la riga, la conferma la mette in lista. E la lista non e' ancora l'inventario applicato - e' solo il tuo foglio di conta.",
			key: 'count',
			placement: 'top',
			target: at('count'),
			timeout: 250,
			title: 'Scrivere quanti ne hai contati',
		},
		{
			body: "Ogni CONFERMA aggiunge una riga qui sotto: data, foto, brand, categoria, modello, nome, variante, sku, fornitore, ean e la quantita' contata. E' il foglio di conta in corso, e resta li' anche se chiudi la pagina e torni domani.",
			key: 'list',
			placement: 'bottom',
			/*
			 * L'intestazione, non la tabella intera: un inventario in corso e' piu'
			 * alto dello schermo e il ritaglio coprirebbe tutto il visibile, facendo
			 * sembrare sparito il velo.
			 */
			target: `${at('list')} thead`,
			timeout: 250,
			title: 'Il foglio di conta',
		},
		{
			body: "Se ti sei sbagliato a contare non serve riscansionare: la quantita' si corregge direttamente nella riga e si salva con il dischetto accanto al campo. I tre pallini a inizio riga hanno una voce sola, Elimina, che toglie la riga dal foglio di conta - e solo da li': il prodotto resta nel catalogo e la sua giacenza non viene toccata.",
			key: 'row-qt',
			placement: 'left',
			target: at('row-qt'),
			timeout: 250,
			title: 'Correggere una riga',
		},
		{
			body: "Il piu' in alto apre una voce sola, Aggiungi prodotto, per mettere in conta un articolo che non riesci a scansionare - codice rovinato, etichetta staccata, prodotto senza barcode.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere a mano',
		},
		{
			body: "Il cestino butta via tutto il foglio di conta, dopo una richiesta di conferma. Le giacenze dei prodotti restano quelle che erano: si ricomincia da zero senza aver cambiato niente. E' la via d'uscita se ti accorgi di aver contato il reparto sbagliato.",
			key: 'delete',
			placement: 'bottom',
			target: at('delete'),
			title: 'Buttare via il conteggio',
		},
		{
			body: "Le due frecce sono il momento in cui l'inventario diventa vero: alla conferma ogni riga sovrascrive la giacenza della sua variante e il foglio di conta viene svuotato. Non si torna indietro. Prima di premerlo conviene ricordare che i prodotti che non hai contato non vengono azzerati - restano come stanno: qui finiscono solo le righe che hai messo in lista.",
			key: 'confirm',
			placement: 'bottom',
			target: at('confirm'),
			title: "Applicare l'inventario",
		},
	];
}
